import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import VersionInfo from './VersionInfo';
const versionHistoryResponseDefaults = {
  versionHistory: [],
  total: 0
};
export default class VersionHistoryResponse extends createImmutableObjectClass(versionHistoryResponseDefaults, {
  fromJSON: (_ref) => {
    let {
      versionHistory
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["versionHistory"]);

    return cleanObject(Object.assign({
      versionHistory: versionHistory.map(version => new VersionInfo(version))
    }, rest));
  },
  toJSON: (_ref2) => {
    let {
      versionHistory
    } = _ref2,
        rest = _objectWithoutPropertiesLoose(_ref2, ["versionHistory"]);

    return Object.assign({
      versionHistory: versionHistory.map(version => version.toJSON())
    }, rest);
  }
}) {}